export default "# Moved\n\nThis topic is not part of the user guide. See [Getting started](/docs/getting-started).\n"